/**
 * commonコンスト
 */

// カレンダーの表示モード
/** 月 */
export const VIEWMODE_DAY_GRID_MONTH = `dayGridMonth`;
/** 日 */
export const VIEWMODE_TIME_GRID_DAY = `timeGridDay`;
/** リスト */
export const VIEWMODE_LIST_MONTH = `listMonth`;
/** リスト */
export const VIEWMODE_LIST_WEEK = `listWeek`;

// sessionStrageで管理しているキー
/** トークン */
export const SESSION_KEY_TOKEN = `token_w_u`;
/** config */
export const SESSION_KEY_CONFIG = `config_w_u`;
/** 休日情報 */
export const SESSION_KEY_HOLIDAYS = `holidays_w_u`;
/** カレンダーの表示モード */
export const SESSION_KEY_VIEW_MODE = `viewMode_w_u`;
/** カレンダーの表示開始日 */
export const SESSION_KEY_START_VIEW_DATE = `startViewDate_w_u`;
/** カレンダーの表示終了日 */
export const SESSION_KEY_END_VIEW_DATE = `endViewDate_w_u`;

// 予約種別
export const BOOKING_TYPE_NAME_LIQUID_WASTE = `廃液`;
export const BOOKING_TYPE_NAME_DEPOSIT = `付着物のみ`;

// 予約種別ごとの色
export const BOOKING_TYPE_COLOR_LIQUID_WASTE = `#5b9bd5`;
export const BOOKING_TYPE_COLOR_DEPOSIT = `#70ad47`;

// 予約種別ごとのclass名
export const BOOKING_TYPE_CLASS_LIQUID_WASTE = `liquidWaste`;
export const BOOKING_TYPE_CLASS_DEPOSIT = `deposit`;

// イベントのグループID
export const GROUP_ID_HOLIDAY = `holiday`;
export const GROUP_ID_FREE = `free`;
export const GROUP_ID_BOOKING = `booking`;

// 休日の色
export const EVENT_HOLIDAY_COLOR = `#D7D7D7`;

/** 予約時間選択ダイアログ */
export const SELECT_BOOKING_TIME_DIAOLG = 0;
/** 予約者情報登録ダイアログ */
export const SUBSCRIBER_INFO_DIALOG = 1;
/** 廃液情報登録ダイアログ */
export const WASTED_LIQUID_SUBSCRIBE_DIALOG = 2;
/** 予約確認ダイアログ */
export const BOOKING_CONFIRM_DIALOG = 3;

/** レスポンシブ切り替え値 */
export const RESPONSIVE_MIN_WIDTH = `(min-width:960px)`;
